import { styled } from '@mui/material';

export const AdminBalanceContainer = styled('div')({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
  paddingBottom: 60,
  alignItems: 'center',
  justifyContent: 'center',
  '.MuiDataGrid-cell:focus': {
    outline: 'none !important',
  },
  '.MuiDataGrid-cell:focus-within': {
    outline: 'none !important',
  },
  '.MuiDataGrid-columnHeader:focus': {
    outline: 'none !important',
  },
  '.MuiDataGrid-columnHeader:focus-within': {
    outline: 'none !important',
  },
});
